module.exports = __webpack_public_path__ + "svg/backbone-defs.svg";